import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

interface TabProps {
  active?: boolean,
  size?: string
}

export const Tab = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})<TabProps>`
  color: ${props => (props.active ? props.theme.colors.primary : '#9ea0a1')};
  padding: 5px 0px;
  cursor: pointer;
  border-bottom: 2px solid ${props => (props.active ? props.theme.colors.primary : 'transparent')};

  ${(props) => {
    switch (props.size) {
      case 'large':
        return `
          font-size: 18px;
          line-height: 32px;
        `;
      default:
        return `
          font-size: 14px;
          line-height: 18px;
        `;
    }
  }}
`;
